(function () {
  function enhanceReview(rev) {
    if (rev.dataset.enhanced) return;
    rev.dataset.enhanced = "true";

    var authorWrapper = rev.querySelector(".jdgm-rev__author-wrapper");
    if (!authorWrapper || authorWrapper.querySelector(".verified-buyer")) return;

    /* ── Verified Buyer badge ── */
    var badge = document.createElement("span");
    badge.classList.add("verified-buyer");
    badge.innerHTML =
      '<img src="//www.wowgood.nl/cdn/shop/files/Eo_circle_onbrand_checkmark-rounded.svg?v=1729504306" alt="Verified" class="checkmark" loading="lazy"> Verified Buyer';
    authorWrapper.appendChild(badge);

    /* ── Product thumbnail + title block ── */
    var product = document.createElement("div");
    product.classList.add("oke-product");

    var link = document.createElement("a");
    link.href = "";
    link.setAttribute("aria-label", "View product");
    link.classList.add("oke-product-thumbnail");

    var galleryImg = document.querySelector(".product-gallery__image img");
    if (galleryImg) {
      var thumb = galleryImg.cloneNode(true);
      thumb.classList.add("oke-product-thumbnail-image");
      link.appendChild(thumb);
    }
    product.appendChild(link);

    var details = document.createElement("div");
    details.classList.add("oke-product-details");

    var reviewing = document.createElement("div");
    reviewing.classList.add("oke-product-details-title");
    reviewing.textContent = " Reviewing ";

    var titleEl = document.querySelector(".product-block--title");
    if (titleEl) {
      var name = titleEl.cloneNode(true);
      name.classList.add("oke-product-details-name");
      details.appendChild(reviewing);
      details.appendChild(name);
    }

    product.appendChild(details);
    authorWrapper.insertAdjacentElement("afterend", product);

    /* ── Move rating + actions inside content ── */
    var content = rev.querySelector(".jdgm-rev__content");
    var rating = rev.querySelector(".jdgm-rev__rating");
    var actions = rev.querySelector(".jdgm-rev__actions");
    if (content && rating) {
      content.appendChild(rating);
      if (actions) content.appendChild(actions);
    }
  }

  function enhanceAll() {
    document.querySelectorAll(".jdgm-rev:not([data-enhanced])").forEach(enhanceReview);
  }

  /* ── Initial pass ── */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enhanceAll);
  } else {
    enhanceAll();
  }

  /* ── Watch for Judge.me pagination / AJAX loads ── */
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (
          node.nodeType === 1 &&
          (node.classList.contains("jdgm-rev") ||
            (node.querySelector && node.querySelector(".jdgm-rev")))
        ) {
          setTimeout(enhanceAll, 50);
          return;
        }
      }
    }
  });

  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
  });
})();


/* ============================================================================
   GOLDEN "ACTIVE REVIEWER" BADGE  ---  Employee 02 Builder, 20-09-2026
   Appended to verified-review-badge.js. The block above is untouched: it still
   adds the "Verified Buyer" line and the Reviewing block.

   WHAT IT DOES
   Puts a small gold pill next to one or two reviewer names in the Judge.me
   widget.

   WHY THE CSS IS IN HERE AND NOT IN A STYLESHEET
   The Verified Buyer styling lives in the apps section's custom_css, which is
   duplicated across five product templates (product, product.easy-test,
   product.social-proof, product.scial-proof-2,
   product.standaard-product-no-vs). Putting the badge there means five edits
   kept in sync by hand. Putting it in styles.css.liquid ties it to one theme.
   Carrying it in the script means the badge works on whichever theme loads
   this file, with nothing else to remember. One <style id="rb-actrev-css">,
   injected once.

   THE PICK IS DETERMINISTIC, NOT RANDOM-PER-LOAD
   Two requirements pull in opposite directions: it must not always land on the
   first reviewer, and it must not shuffle on every page load. So there is no
   Math.random anywhere here. Each review gets a hash of (Judge.me product id +
   that review's own review id). The lowest one or two hashes win. Both inputs
   are language-invariant and survive a reload, a sort change and a cache
   purge, so:
     - the same product always badges the same people
     - a different product badges different positions in its list
     - /nl and /de badge the same people as /en
   Change SALT below and every product reshuffles at once.

   HOW MANY
     < 3 reviews on screen  -> none. One badge out of two reviewers reads as a
                               gimmick rather than a signal.
     3 reviews              -> one
     4 or more              -> one or two, decided by the product hash
   Judge.me paginates by replacing the list, so page two recomputes over the
   reviews it now shows and badges its own one or two.

   LANGUAGE
   From <html lang>, first two letters, nb/nn folded into no. Anything not in
   the table falls back to English. The label is written already translated, so
   a DOM translator finds no English string to swap. It is written once and
   never rewritten, on purpose: rewriting on every pass would fight any
   translator watching the same subtree.
   ============================================================================ */
(function () {
  var SALT = "wowgood-2026";

  var L = {
    en: "Active reviewer",
    nl: "Actieve reviewer",
    de: "Aktiver Rezensent",
    fr: "Contributeur actif",
    it: "Recensore attivo",
    es: "Reseñador activo",
    pt: "Avaliador ativo",
    da: "Aktiv anmelder",
    sv: "Aktiv recensent",
    no: "Aktiv anmelder",
    fi: "Aktiivinen arvostelija",
    pl: "Aktywny recenzent",
    zh: "活跃评论者"
  };

  function label() {
    var raw = (document.documentElement.getAttribute("lang") || "en").toLowerCase();
    var two = raw.slice(0, 2);
    if (two === "nb" || two === "nn") two = "no";
    return L[two] || L.en;
  }

  var CSS = [
    ".rb-actrev{display:inline-flex;align-items:center;gap:4px;margin-left:8px;",
    "padding:2px 8px 2px 6px;vertical-align:middle;white-space:nowrap;border-radius:999px;",
    "background:linear-gradient(115deg,#A8863F 0%,#C9A961 22%,#F3E2B5 44%,#C9A961 66%,#A8863F 100%);",
    "background-size:260% 100%;background-position:12% 50%;color:#2A1016 !important;",
    "font-size:10.5px;font-weight:800;line-height:1.6;letter-spacing:.07em;text-transform:uppercase;",
    "font-style:normal;text-decoration:none;",
    "box-shadow:0 1px 3px rgba(42,16,22,.34),inset 0 1px 0 rgba(255,255,255,.45);",
    "animation:rb-actrev-sheen 9s ease-in-out infinite;}",
    ".rb-actrev__t{color:#2A1016 !important;}",
    ".rb-actrev__i{width:11px;height:11px;flex:0 0 11px;fill:#2A1016;display:block;}",
    /* The sheen rests for most of the cycle and sweeps once. A loop that never
       rests reads as a broken element rather than a highlight. */
    "@keyframes rb-actrev-sheen{0%,62%{background-position:12% 50%}",
    "80%{background-position:88% 50%}100%{background-position:12% 50%}}",
    "@media (prefers-reduced-motion:reduce){.rb-actrev{animation:none}}",
    "@media only screen and (max-width:480px){",
    ".rb-actrev{margin-left:6px;padding:1px 7px 1px 5px;font-size:9.5px;letter-spacing:.05em;}",
    ".rb-actrev__i{width:10px;height:10px;flex:0 0 10px;}}"
  ].join("");

  function injectCss() {
    if (document.getElementById("rb-actrev-css")) return;
    var s = document.createElement("style");
    s.id = "rb-actrev-css";
    s.appendChild(document.createTextNode(CSS));
    (document.head || document.documentElement).appendChild(s);
  }

  var SPARK =
    '<svg class="rb-actrev__i" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 0l2.6 7.4L22 10l-7.4 2.6L12 20l-2.6-7.4L2 10l7.4-2.6z"/></svg>';

  /* FNV-1a, 32 bit. Small, fast, no dependency, spreads short ids well. */
  function fnv(s) {
    var h = 2166136261 >>> 0;
    for (var i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h = Math.imul(h, 16777619) >>> 0;
    }
    return h >>> 0;
  }

  /* Judge.me puts the Shopify product id on the widget as data-id. Same number
     on every language URL, which is what keeps the pick stable across markets.
     Two fallbacks behind it. */
  function productKey() {
    var w = document.querySelector(".jdgm-review-widget[data-id], .jdgm-widget[data-id]");
    var id = w && w.getAttribute("data-id");
    if (id) return id;
    try {
      if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
        return String(ShopifyAnalytics.meta.product.id);
      }
    } catch (e) {}
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : location.pathname;
  }

  /* data-review-id is a uuid Judge.me carries on every review node. */
  function reviewKey(rev) {
    var id = rev.getAttribute("data-review-id");
    if (id) return id;
    var a = rev.querySelector(".jdgm-rev__author");
    var t = rev.querySelector(".jdgm-rev__timestamp");
    return (
      ((a && a.textContent) || "") +
      "|" +
      ((t && t.getAttribute("data-content")) || (t && t.textContent) || "")
    );
  }

  function goldPass() {
    var revs = Array.prototype.slice.call(document.querySelectorAll(".jdgm-rev"));
    if (!revs.length) return;
    injectCss();

    var pk = SALT + ":" + productKey();
    var n = revs.length < 3 ? 0 : revs.length < 4 ? 1 : 1 + (fnv(pk + "#count") % 2);

    var scored = revs.map(function (r, i) {
      return { el: r, i: i, s: fnv(pk + "|" + reviewKey(r)) };
    });
    scored.sort(function (a, b) {
      return a.s - b.s || a.i - b.i;
    });

    var win = scored.slice(0, n).map(function (o) {
      return o.el;
    });

    revs.forEach(function (r) {
      var cur = r.querySelector(".rb-actrev");
      var want = win.indexOf(r) !== -1;

      if (want && !cur) {
        var author = r.querySelector(".jdgm-rev__author");
        if (!author) return;
        var b = document.createElement("span");
        b.className = "rb-actrev";
        b.innerHTML = SPARK + '<span class="rb-actrev__t">' + label() + "</span>";
        author.insertAdjacentElement("afterend", b);
      } else if (!want && cur && cur.parentNode) {
        cur.parentNode.removeChild(cur);
      }
      /* want && cur: leave it alone. See the note about DOM translators. */
    });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(goldPass, 180);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", schedule);
  } else {
    schedule();
  }

  /* Judge.me injects late. Poll for eight seconds, then stop and let the
     observer carry it. */
  var tries = 0;
  var poll = setInterval(function () {
    tries++;
    if (document.querySelector(".jdgm-rev") || tries > 20) {
      schedule();
      clearInterval(poll);
    }
  }, 400);

  /* Same guard as the block above: only wake on nodes that are, or contain, a
     review. Inserting a <span> into an existing review does not match, so this
     cannot feed itself. */
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (
          node.nodeType === 1 &&
          (node.classList.contains("jdgm-rev") ||
            (node.querySelector && node.querySelector(".jdgm-rev")))
        ) {
          schedule();
          return;
        }
      }
    }
  });

  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true
  });
})();
